var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"system-curve-wrap"},_vm._l((_vm.recommendCurves),function(item,index){return _c('system-curve-item',{key:index,attrs:{"active":_vm.currentSelectedIndex === index,"curve-item":item},on:{"click":function($event){return _vm.click(item,index)},"onFavoriteClick":function($event){return _vm.onFavoriteClick(item,index)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }